/* eslint-disable */
import { ICalendarItem, useDictionary } from '../../shared';
import React from 'react';
import type {FC} from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import { CalendarBASF } from '../CalendarBASF';
import { CalendarBASFPropsType } from '../CalendarBASF/types';
import { dictionaryService } from '../../dataFlow';
import { DictionaryItem } from '@sa/rep-mdm';

export const CalendarMonth: FC<CalendarBASFPropsType> = (props => {
  const intl = useIntl();
  const { label, items:itemsProps, dictionary, parameter, disabled, multiple } = props;
  const [items, setItems] = React.useState<ICalendarItem[]>();

  const [dictItems] = useDictionary(dictionaryService, itemsProps ? undefined : props.dictionary);
  React.useEffect(() => {
    const itemsSource = (itemsProps || dictItems) as (DictionaryItem[] | null);
    if (itemsSource) {
      const weekFrequency = "7";
      const nextItems = itemsSource.map<ICalendarItem>(x => ({
        id: x.id?.toString(),
        name: (x.getValue<string | number>("name"))?.toString() || '',
        parent: (x.getValue<string | number>("parent"))?.toString() || '',
        frequency: `${x.getValue<string | number>("frequencyId")}`?.toString() || ''
      })).filter(item => item.frequency !== weekFrequency);
      setItems(nextItems);
    }
  }, [dictItems, itemsProps]);
  const labelMessage = label || intl.formatMessage(messages.title);
  return (
    <CalendarBASF isDeep multiple={multiple} disabled={disabled} onChange={props.onChange} value={props.value} label={labelMessage} items={items} dictionary={dictionary} parameter={parameter} />
  );
});